import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { PaginatePipe } from 'src/app/pipes/paginate.pipe';
import { PipeModule } from 'src/app/pipes/pipe-module';
import { NgxSpinnerModule } from "ngx-spinner";
import { MatMenuModule } from '@angular/material/menu';
import { AdminMantenimientoFamiliasBackview } from './admin-mantenimiento-familias.component.backview';
import { HeaderModule } from '../header/header.module';
import { FooterModule } from '../footer/footer.module';

@NgModule({
  declarations: [AdminMantenimientoFamiliasBackview
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatPaginatorModule,
    PipeModule,
    HeaderModule,
    FooterModule,
    NgxSpinnerModule,
    MatMenuModule
  ],
  exports: [
    AdminMantenimientoFamiliasBackview]
})
export class AdminMantenimientoFamiliasModule { }
